import { Box, CircularProgress, Icon, Typography } from '@mui/material'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import PerfSortTable from 'components/reusable/table/PerfSortTable'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { getAllAppraisal } from 'services/api/modules/performance/appraisal/appraisal'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const ACTabs = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [activeTab, setActiveTab] = useState([])
  const [completedTab, setCompletedTab] = useState([])
  const queryClient = useQueryClient()
  const [mainAppraisalTabsValue, setAppraisalTabsValue] = useState(
    location?.state?.mainAppraisalTabsValue || 0
  )

  useEffect(() => {
    queryClient.invalidateQueries('allAppraisalData')
    queryClient.resetQueries('allAppraisalData')
  }, [])

  // API integration
  const { isLoading } = useQuery('allAppraisalData', async () => {
    const { data } = await getAllAppraisal()

    // Active Tab
    data[1] && data[2]
      ? setActiveTab(data[1].concat(data[2]))
      : data[1]
      ? setActiveTab(data[1])
      : data[2]
      ? setActiveTab(data[2])
      : setActiveTab([])

    // Completed Tab
    data[3] && data[4]
      ? setCompletedTab(data[3].concat(data[4]))
      : data[3]
      ? setCompletedTab(data[3])
      : data[4]
      ? setCompletedTab(data[4])
      : setCompletedTab([])
  })

  const formatCourseDate = (date) => {
    const dateObj = new Date(date + 'T00:00:00')
    return new Intl.DateTimeFormat('en-GB').format(dateObj)
  }

  const tableColumn = [
    {
      Header: 'Appraisal',
      accessor: 'label',
      Cell: (props) => {
        const { value } = props

        return <Typography textTransform="capitalize">{value}</Typography>
      },
    },
    {
      Header: 'Start Date',
      accessor: 'start_date',
      Cell: (props) => {
        const { value } = props

        return <Typography>{formatCourseDate(value)}</Typography>
      },
    },
    {
      Header: 'End Date',
      accessor: 'due_date',
      Cell: (props) => {
        const { value } = props

        return <Typography>{formatCourseDate(value)}</Typography>
      },
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: (props) => {
        const { value } = props

        return (
          <>
            {value === 1 ? (
              <Typography>Scheduled</Typography>
            ) : value === 2 ? (
              <Typography color="positive.main">Active</Typography>
            ) : value === 3 ? (
              <Typography>Completed</Typography>
            ) : (
              <Typography color="light-gray-text.main">Cancelled</Typography>
            )}
          </>
        )
      },
    },
  ]

  const tableFunction = (item) => {
    let mainAppraisalTabsValue = 0
    switch (item.status) {
      case 1:
      case 2:
        mainAppraisalTabsValue = 0
        break
      default:
        mainAppraisalTabsValue = 1
        break
    }
    navigate(`/app/appraisal-cycle/details/${item.id}`, {
      state: { ...item, mainAppraisalTabsValue: mainAppraisalTabsValue },
    })
  }

  return (
    <Box
      sx={{
        bgcolor: 'white.main',
        border: 1,
        borderColor: 'gray-line.main',
        borderRadius: '4.5px',
      }}
    >
      <AdxTabsBadge
        initialValue={mainAppraisalTabsValue}
        sxPanel={{
          backgroundColor: 'transparent',
        }}
        scrollButtons={false}
      >
        <AdxTabsPanel notification={activeTab.length} label="Active">
          {isLoading ? (
            <Box height="60vh" display="flex" justifyContent="center" alignItems="center">
              <CircularProgress color="alternate" size={60} />
            </Box>
          ) : (
            <>
              {activeTab.length !== 0 ? (
                <PerfSortTable
                  column={tableColumn}
                  data={activeTab}
                  nav="View"
                  onClick={tableFunction}
                  sxHeader
                  sxNav={{ textDecoration: 'underline' }}
                  sxCell
                  sx={{ boxShadow: 'none' }}
                  height="calc(100vh - 280px)"
                  stickyHeader
                />
              ) : (
                <AdxEmptyStateV2
                  icon={<Icon>track_changes</Icon>}
                  title="No active appraisal"
                  height="calc(100vh - 280px)"
                />
              )}
            </>
          )}
        </AdxTabsPanel>
        <AdxTabsPanel notification={completedTab.length} label="Completed">
          {isLoading ? (
            <Box height="60vh" display="flex" justifyContent="center" alignItems="center">
              <CircularProgress color="alternate" size={60} />
            </Box>
          ) : (
            <>
              {completedTab.length !== 0 ? (
                <PerfSortTable
                  column={tableColumn}
                  data={completedTab}
                  nav="View"
                  onClick={tableFunction}
                  sxHeader
                  sxNav={{ textDecoration: 'underline' }}
                  sxCell
                  sx={{ boxShadow: 'none' }}
                  height="calc(100vh - 280px)"
                  stickyHeader
                />
              ) : (
                <AdxEmptyStateV2
                  icon={<Icon>track_changes</Icon>}
                  title="No completed appraisal"
                  height="calc(100vh - 280px)"
                />
              )}
            </>
          )}
        </AdxTabsPanel>
      </AdxTabsBadge>
    </Box>
  )
}

export default ACTabs
